import { createFileRoute } from '@tanstack/react-router';

import { VacanciesPageContent } from '~/components/vacancies/VacanciesPageContent';
import { getOpenVacancies } from '~/lib/peopleforce';

const VacanciesPage = () => {
  const vacanciesData = Route.useLoaderData();
  return <VacanciesPageContent vacanciesData={vacanciesData} />;
};

export const Route = createFileRoute('/$locale/vacancies')({
  loader: () => getOpenVacancies(),
  component: VacanciesPage,
});
